import { setInventoryPolicyToVariants } from './setInventoryPolictyToVariants';
import InventoryPolicy from './inventoryPolicy';

export const handleVariantsInventoryPolicyChange = ({
  isToggleOn,
  variants,
  onChange,
}) => {
  const variantStatus = isToggleOn
    ? InventoryPolicy.Continue
    : InventoryPolicy.Deny;

  const updatedVariants = setInventoryPolicyToVariants({
    variants,
    inventoryPolicy: variantStatus,
  });

  onChange('variants', updatedVariants);
};
